import { businessTruthSchema } from "@/domain/schemas";
import type { BusinessTruth, DiscoveryQuestion, Scenario } from "@/domain/types";

export function validateBusinessTruth(value: unknown): BusinessTruth {
  const truth = businessTruthSchema.parse(value);
  const productIds = new Set(truth.products.map((item) => item.id));
  const serviceIds = new Set(truth.services.map((item) => item.id));
  const scenarioIds = new Set(truth.scenarios.map((item) => item.id));
  if (!scenarioIds.has(truth.business.defaultScenarioId)) throw new Error("Business defaultScenarioId must reference an existing Scenario.");
  for (const scenario of truth.scenarios) {
    if (scenario.productIds.some((id) => !productIds.has(id))) throw new Error(`Scenario ${scenario.id} references an unknown Product.`);
    if (scenario.serviceIds.some((id) => !serviceIds.has(id))) throw new Error(`Scenario ${scenario.id} references an unknown Service.`);
  }
  return truth;
}

export function defaultScenario(truth: BusinessTruth): Scenario {
  const scenario = truth.scenarios.find((item) => item.id === truth.business.defaultScenarioId && item.status === "active");
  if (!scenario) throw new Error("The default Discovery Scenario is unavailable.");
  return scenario;
}

export function scenarioQuestions(scenario: Scenario): DiscoveryQuestion[] {
  return scenario.steps.flatMap((step) => step.questions);
}
